/** 管理画面共通スタイル（やわらかめ・落ち着いたトーン + teal アクセント） */
export const adminCard =
  'bg-white rounded-2xl shadow-sm border border-stone-200/90 p-4 sm:p-6';

export const adminCardAccent =
  'bg-white rounded-2xl shadow-sm border border-stone-200/90 border-l-4 border-l-teal-400 p-4 sm:p-6';

export const adminCard2 =
  'bg-white rounded-2xl shadow-sm border border-stone-200/90 px-4 sm:px-4';

export const adminSectionTitleBase =
  'text-base sm:text-lg font-medium text-stone-800';

export const adminSectionTitle =
  `${adminSectionTitleBase} pb-3 mb-4 border-l-4 border-teal-400 pl-3`;

export const adminSectionTitleToolbar =
  `${adminSectionTitleBase} mb-0 pb-0`;

export const adminMutedText = 'text-stone-600';

export const adminInteractive =
  'cursor-pointer text-teal-600 hover:text-teal-700 hover:underline transition-colors';

export const adminInput =
  'border border-stone-300 rounded-xl py-2 px-3 text-stone-700 bg-white focus:outline-none focus:ring-2 focus:ring-teal-100 focus:border-teal-400 w-full sm:w-auto';

export const adminTableHead = 'bg-stone-50 text-stone-700 font-medium';

export const adminTableCell =
  'border border-stone-200 p-2 sm:p-3 text-stone-700 text-sm sm:text-base whitespace-nowrap';

export const adminTableWrap = 'overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0';

export const adminTable = 'w-full border-collapse mb-5 table-fixed';

export const adminTableCellName =
  'border border-stone-200 p-2 sm:p-3 text-stone-700 text-sm sm:text-base whitespace-nowrap overflow-hidden text-ellipsis max-w-0';

export const adminPageToolbar =
  'flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-5 border-b border-stone-200/80 pb-3';

export const adminFilterRow =
  'flex flex-col gap-2 sm:flex-row sm:items-center mt-4 mb-4';

export const adminHeaderBar =
  'bg-white/90 p-4 sm:p-5 mb-4 sm:mb-6 rounded-2xl shadow-sm border border-stone-200/90 border-l-4 border-l-teal-400 flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center';

export const adminButtonPrimary =
  'bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-xl px-5 py-2 shadow-sm shadow-teal-500/20 transition-colors text-sm sm:text-base';

export const adminButtonPrimaryBlock =
  `${adminButtonPrimary} w-full sm:w-auto text-center`;

export const adminModalPanel =
  'relative mx-4 w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl border border-stone-200 bg-white p-4 sm:p-6 shadow-lg';

export const adminStatCard =
  'rounded-2xl border border-teal-100/90 bg-gradient-to-br from-teal-50/90 to-white p-4 shadow-sm';

export const adminStatLabel = 'text-sm font-medium text-teal-700/80';

export const adminStatValue = 'text-2xl font-semibold text-stone-800 tracking-tight';

export const adminBadge =
  'inline-flex items-center rounded-full bg-teal-50 px-3 py-1 text-xs font-medium text-teal-700 ring-1 ring-teal-100';

export const adminNavLink =
  'flex items-center gap-3 rounded-xl px-3 py-2.5 text-stone-600 no-underline transition-all duration-200 hover:bg-white/80 hover:text-stone-800 hover:shadow-sm';

export const adminNavLinkActive =
  'flex items-center gap-3 rounded-xl border border-teal-100/80 bg-white px-3 py-2.5 font-medium text-teal-800 no-underline shadow-sm shadow-teal-500/10';
